// extracted by css-extract-rspack-plugin
var _1 = "deleteAction-pRU3y5";
var _2 = "notice-KMp25Y";
var _3 = "prompt-G4UPeo";
export { _1 as "deleteAction", _2 as "notice", _3 as "prompt" }
